import { INormalizedChartDate } from "../types";
import { formatChartDate } from "./formatChartDate";



export const createEmptyEntry = (
  date: Date,
  isAfterLastDate: boolean = false
): INormalizedChartDate => ({
  created_at: date.toISOString(),
  date: formatChartDate(date.toISOString()),
  isAfterLastDate,
  empty: isAfterLastDate,
  visibility: null,
  sentiment: null,
  ranking: null,
});
